import { createStyles } from '@codeleap/styles'
import { PaginationButtonsComposition } from '@codeleap/web'
import { textVariant } from './Text'
import { StyleRegistry } from '../styles'

const createPaginationButtonVariant = createStyles<PaginationButtonsComposition>

export const PaginationButtonStyles = {
  default: createPaginationButtonVariant((theme) => {

    const defaultButtonStyles = {
      minWidth: theme.size.large,
      minHeight: theme.size.large,
      backgroundColor: theme.baseColors.neutralSolid200,
      borderRadius: theme.radius.small,
      '&:hover': {
        backgroundColor: theme.baseColors.primarySolid400,
      },
      '&:hover > p': {
        color: theme.baseColors.neutralSolid0,
      },
      [theme.media.down('tabletSmall')]: {
        minWidth: theme.size.small,
        minHeight: theme.size.small,
      },
    }

    return (
      {
        wrapper: {
          minHeight: 'auto',
          ...theme.spacing.gap(2),
          [theme.media.down('tabletSmall')]: {
            ...theme.spacing.gap(1),
          },
        },
        buttonWrapper: {
          ...defaultButtonStyles,
        },
        'buttonWrapper:selected': {
          backgroundColor: theme.baseColors.primarySolid500,
          'p': {
            color: theme.baseColors.neutralSolid0,
          },
        },
        buttonText: {
          color: theme.baseColors.primarySolid500,
          '&:hover > p': {
            color: theme.baseColors.neutralSolid0,
          },
          [theme.media.down('tabletSmall')]: {
            ...textVariant('p3'),
          },
        },
        arrowLeftButtonWrapper: {
          ...defaultButtonStyles,
        },
        arrowRightButtonWrapper: {
          ...defaultButtonStyles,
        },
      }
    )
  }),
}

StyleRegistry.registerVariants('PaginationButtons', PaginationButtonStyles)
